export default __webpack_public_path__ + "static/media/53b.c4220a29.gif";